import { render } from "./UnitLogbook.vue?vue&type=template&id=667b9c5e&scoped=true"
import script from "./UnitLogbook.vue?vue&type=script&lang=js"
export * from "./UnitLogbook.vue?vue&type=script&lang=js"

import "./UnitLogbook.vue?vue&type=style&index=0&id=667b9c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667b9c5e"]])

export default __exports__